VjsAdmin.LicenseSearchSelect = (() => {
    const me = {
        selectedDistrictIds: [],
        licenseFilterData: [],
        districtFilterData: [],
    };

    const removeSelectedDistrictLicenses = () => {
        const licenseSelect2 = $('#license-search-select2');
        const licenses = licenseSelect2.select2('data');
        const selectedLicenseIds = licenses
            .filter((l) => !me.selectedDistrictIds.includes(l.districtId))
            .map((l) => l.id);
        const removedLicenses = licenses
            .filter((l) => me.selectedDistrictIds.includes(l.districtId))
            .map((l) => l.text)
            .join(', ');
        if (licenses.length !== selectedLicenseIds.length) {
            licenseSelect2.val(selectedLicenseIds);
            licenseSelect2.change();

            const notificationText = `The following licenses were removed because the parent district was added: ${removedLicenses}. 
                Districts supersede licenses.`;
            VjsUtility.Notification.info({
                text: notificationText,
                time: 5000,
            });
        }
    };

    const districtSearchOnChange = () => {
        const districtSelect2 = $('#district-search-select2');
        districtSelect2.on('change', () => {
            me.selectedDistrictIds = districtSelect2
                .select2('data')
                .map((d) => parseInt(d.id, 10));
            removeSelectedDistrictLicenses();
        });
    };

    const init = (
        parent = document.querySelector('body'),
        filterData = [],
        watchDistrictSelect = false,
    ) => {
        if (filterData.length > 0) {
            me.licenseFilterData = filterData.map(
                (item) => parseInt(item.license_id, 10)
                    || parseInt(item.district_id, 10),
            );
            me.districtFilterData = filterData
                .filter((item) => !item.license_id)
                .map((item) => parseInt(item.district_id, 10));
        }

        const licenseSelect2 = $('#license-search-select2');
        if (licenseSelect2.hasClass('select2-hidden-accessible')) {
            return;
        }
        if (watchDistrictSelect) {
            districtSearchOnChange();
        }

        licenseSelect2.select2({
            ajax: {
                type: 'POST',
                url: Slim.Router.pathFor('api.licenses.list.json'),
                dataType: 'json',
                delay: 250,
                data(params) {
                    return {
                        search_term: params.term,
                    };
                },
                processResults(data) {
                    let licenses = data.data;

                    if (me.selectedDistrictIds.length) {
                        licenses = licenses.filter(
                            (l) => !me.selectedDistrictIds.includes(l.district_id),
                        );
                    }
                    let newItems = licenses.map((item) => ({
                        id: item.license_id,
                        districtId: item.district_id,
                        text: `${item.license_name} : ${item.license_id}`,
                    }));

                    if (me.licenseFilterData.length > 0) {
                        newItems = newItems.filter(
                            (item) => !me.licenseFilterData.includes(item.id),
                        );
                    }

                    if (me.districtFilterData.length > 0) {
                        newItems = newItems.filter(
                            (item) => !me.districtFilterData.includes(item.districtId),
                        );
                    }

                    return {
                        results: newItems,
                        pagination: {
                            more: false,
                        },
                    };
                },
            },
            placeholder: 'Search for a license',
            minimumInputLength: 3,
            theme: 'bootstrap4',
            dropdownParent: parent,
        });
    };

    return {
        init,
    };
})();
